import React from "react";
import { Container, Row } from "react-bootstrap";
import { FaGraduationCap, FaBriefcase } from "react-icons/fa";
import "../../style.css";

const EducationExperience = () => {
  const education = [
    {
      title: "B.Tech in Electronics & Communication Engineering",
      place: "NSRIT College, Visakhapatnam",
      year: "2020 - 2024",
      desc: "Focused on Java, Web Development, and Database Management Systems. During my college years, I developed a Fingerprint-Based Attendance System using fingerprint sensors to automate and improve the accuracy of student attendance tracking.",
    },
    {
      title: "Intermediate (MPC)",
      place: "Sri Chaitanya Junior College",
      year: "2018 - 2020",
      desc: "Studied core mathematics and physics with strong analytical focus.",
    },
    {
      title: "Secondary School Education (10th Grade)",
      place: "Bhashyam English Medium School",
      year: "2017 - 2018",
      desc: "Completed secondary education with a strong foundation in mathematics, science, and problem-solving skills.",
    },
  ];

  const experience = [
    {
      title: "Junior Software Engineer",
      place: "FluentGrid",
      year: "2025 - Present",
      desc: "Worked on multiple web applications using Spring Boot and React.js. Developed a Task Management Application featuring task creation, assignment, progress tracking, user authentication, and role-based access. Additionally, contributed to converting the existing EPI project into a React-based application for improved performance and scalability.",
    },
    {
      title: "Java Full Stack Intern",
      place: "CVCORP",
      year: "2024",
      desc: "Gained hands-on experience in HTML, CSS, and Data Structures & Algorithms (DSA). Developed a Student Management System using Java, HTML, CSS, and MySQL, focusing on CRUD operations, data validation, and user-friendly UI design.",
    },
  ];

  return (
    <Container fluid className="edu-exp-section" id="education">
      <h1 className="edu-exp-heading">
        My <strong className="purple">Education</strong> &{" "}
        <strong className="purple">Experience</strong>
      </h1>
      <p className="edu-exp-subtext">
        A quick overview of my academic and professional journey.
      </p>

      <Row className="edu-exp-grid">
        {/* Education */}
        <div className="edu-exp-group">
          <div className="edu-exp-header">
            <FaGraduationCap className="edu-exp-icon_1" />
            <h2 className="edu-exp-title">Education</h2>
          </div>
          {education.map((item, index) => (
            <div key={index} className="edu-exp-card">
              <h3>{item.title}</h3>
              <p className="edu-exp-place">
                {item.place} | <span className="purple">{item.year}</span>
              </p>
              <p className="edu-exp-desc">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* Experience */}
        <div className="edu-exp-group">
          <div className="edu-exp-header">
            <FaBriefcase className="edu-exp-icon_2" />
            <h2 className="edu-exp-title">Experience</h2>
          </div>
          {experience.map((item, index) => (
            <div key={index} className="edu-exp-card">
              <h3>{item.title}</h3>
              <p className="edu-exp-place">
                {item.place} | <span className="purple">{item.year}</span>
              </p>
              <p className="edu-exp-desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </Row>
    </Container>
  );
};

export default EducationExperience;
